import { render, staticRenderFns } from "./NewsSingle.vue?vue&type=template&id=ef91f1be"
import script from "./NewsSingle.vue?vue&type=script&lang=js"
export * from "./NewsSingle.vue?vue&type=script&lang=js"
import style0 from "./NewsSingle.vue?vue&type=style&index=0&id=ef91f1be&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports